// Generated by TsRpcGenerator, do not modify manually
// @ts-nocheck
// noinspection JSUnusedGlobalSymbols, ES6UnusedImports

import { Observable } from "rxjs"
import { InitializedChannel } from "../api-types.ts"
import type { AppDate, AppDateTime, Nominal, Pair, Ref } from "../api-types.ts"
import { getInitial, getResult, getUpdates } from "../types.ts"

import { ApiService } from "../ApiService.ts"

import { InitRuntimeConfigTaskState, ProjectCodingGuidelines, ProjectKey, ProjectSecretWithValue, TID } from "./TypeDefinitions.ts"

export interface InitRuntimeConfigApi {
  addPreviewCommand(taskId: TID, id: string, title: string, script: string, port: number | null): Promise<void>

  complete(taskId: TID): Promise<TID | null>

  configurePreviewRuntime(projectKey: ProjectKey, repository: string): Promise<TID>

  continuePreviewRuntimeConfigWithSecrets(taskId: TID, secrets: ProjectSecretWithValue[], messageId: TID | null): Promise<void>

  continuePreviewRuntimeConfigWithServices(taskId: TID, services: InitRuntimeConfigTaskState.Service[]): Promise<void>

  deleteSecretInSetupTask(taskId: TID, key: string): Promise<void>

  getRuntimeEnvironmentDescription(taskId: TID): Promise<string>

  getTaskGuidelines(taskId: TID): Promise<ProjectCodingGuidelines | null>

  removePreviewCommand(taskId: TID, commandId: string): Promise<void>

  reorderPreviewCommands(taskId: TID, commandIds: string[]): Promise<void>

  saveBeforeCommand(taskId: TID, script: string): Promise<void>

  savePreviewCommand(taskId: TID, commandId: string, script: string): Promise<void>

  savePreviewPort(taskId: TID, port: number, serviceId: string): Promise<void>

  stopBeforeCommand(taskId: TID): Promise<void>

  stopPreviewCommand(taskId: TID, commandId: string): Promise<void>

  updateSecretInSetupTask(taskId: TID, secret: ProjectSecretWithValue): Promise<void>

  updateTaskGuidelines(taskId: TID, content: string): Promise<void>

  verifyBeforeCommand(taskId: TID): Promise<void>

  verifyPreviewCommand(taskId: TID, commandId: string): Promise<void>
}

export class InitRuntimeConfigApiClient implements InitRuntimeConfigApi {
  constructor(private service: ApiService) {}

  async addPreviewCommand(taskId: TID, id: string, title: string, script: string, port: number | null): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/addPreviewCommand", {
      taskId: taskId,
      id: id,
      title: title,
      script: script,
      port: port,
    }))
  }

  async complete(taskId: TID): Promise<TID | null> {
    return getResult(await this.service.rpc<TID | null, never>("InitRuntimeConfigApi/complete", {
      taskId: taskId,
    }))
  }

  async configurePreviewRuntime(projectKey: ProjectKey, repository: string): Promise<TID> {
    return getResult(await this.service.rpc<TID, never>("InitRuntimeConfigApi/configurePreviewRuntime", {
      projectKey: projectKey,
      repository: repository,
    }))
  }

  async continuePreviewRuntimeConfigWithSecrets(taskId: TID, secrets: ProjectSecretWithValue[], messageId: TID | null): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/continuePreviewRuntimeConfigWithSecrets", {
      taskId: taskId,
      secrets: secrets,
      messageId: messageId,
    }))
  }

  async continuePreviewRuntimeConfigWithServices(taskId: TID, services: InitRuntimeConfigTaskState.Service[]): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/continuePreviewRuntimeConfigWithServices", {
      taskId: taskId,
      services: services,
    }))
  }

  async deleteSecretInSetupTask(taskId: TID, key: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/deleteSecretInSetupTask", {
      taskId: taskId,
      key: key,
    }))
  }

  async getRuntimeEnvironmentDescription(taskId: TID): Promise<string> {
    return getResult(await this.service.rpc<string, never>("InitRuntimeConfigApi/getRuntimeEnvironmentDescription", {
      taskId: taskId,
    }))
  }

  async getTaskGuidelines(taskId: TID): Promise<ProjectCodingGuidelines | null> {
    return getResult(await this.service.rpc<ProjectCodingGuidelines | null, never>("InitRuntimeConfigApi/getTaskGuidelines", {
      taskId: taskId,
    }))
  }

  async removePreviewCommand(taskId: TID, commandId: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/removePreviewCommand", {
      taskId: taskId,
      commandId: commandId,
    }))
  }

  async reorderPreviewCommands(taskId: TID, commandIds: string[]): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/reorderPreviewCommands", {
      taskId: taskId,
      commandIds: commandIds,
    }))
  }

  async saveBeforeCommand(taskId: TID, script: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/saveBeforeCommand", {
      taskId: taskId,
      script: script,
    }))
  }

  async savePreviewCommand(taskId: TID, commandId: string, script: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/savePreviewCommand", {
      taskId: taskId,
      commandId: commandId,
      script: script,
    }))
  }

  async savePreviewPort(taskId: TID, port: number, serviceId: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/savePreviewPort", {
      taskId: taskId,
      port: port,
      serviceId: serviceId,
    }))
  }

  async stopBeforeCommand(taskId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/stopBeforeCommand", {
      taskId: taskId,
    }))
  }

  async stopPreviewCommand(taskId: TID, commandId: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/stopPreviewCommand", {
      taskId: taskId,
      commandId: commandId,
    }))
  }

  async updateSecretInSetupTask(taskId: TID, secret: ProjectSecretWithValue): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/updateSecretInSetupTask", {
      taskId: taskId,
      secret: secret,
    }))
  }

  async updateTaskGuidelines(taskId: TID, content: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/updateTaskGuidelines", {
      taskId: taskId,
      content: content,
    }))
  }

  async verifyBeforeCommand(taskId: TID): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/verifyBeforeCommand", {
      taskId: taskId,
    }))
  }

  async verifyPreviewCommand(taskId: TID, commandId: string): Promise<void> {
    return getResult(await this.service.rpc<void, never>("InitRuntimeConfigApi/verifyPreviewCommand", {
      taskId: taskId,
      commandId: commandId,
    }))
  }

}

